import { render, staticRenderFns } from "./CheckWrapper.vue?vue&type=template&id=35910f42&scoped=true&"
import script from "./CheckWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckWrapper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CheckWrapper.vue?vue&type=style&index=0&id=35910f42&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "35910f42",
  null
  ,true
)

export default component.exports